import { render, staticRenderFns } from "./EmployeeEducationDetailEditModal.vue?vue&type=template&id=761b66ec&scoped=true&"
import script from "./EmployeeEducationDetailEditModal.vue?vue&type=script&lang=js&"
export * from "./EmployeeEducationDetailEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761b66ec",
  null
  
)

export default component.exports